import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PostForm from '../components/PostForm';
import { fetchPostById, updatePost } from '../api/postApi';
import { buildPostPayload, applyPostFormFieldChange, mapPostToForm } from '../utils/postForm';

function PostDetailPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const post = await fetchPostById(id);
        setForm(mapPostToForm(post));
      } catch (error) {
        window.alert(`상세 조회 실패: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  const onChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => applyPostFormFieldChange(prev, name, value));
  };

  const onUpdate = async () => {
    if (!form) return;
    setSaving(true);
    try {
      await updatePost(id, buildPostPayload(form));
      window.alert('수정이 완료되었습니다.');
      navigate('/posts');
    } catch (error) {
      window.alert(`수정 실패: ${error.message}`);
    } finally {
      setSaving(false);
    }
  };

  if (loading || !form) {
    return <p className="page">불러오는 중...</p>;
  }

  return (
    <section className="page">
      <h2>AS 상세 조회 / 수정</h2>
      <PostForm form={form} onChange={onChange} mode="edit" />
      <div className="button-row">
        <button type="button" className="secondary" onClick={() => navigate('/posts')}>
          목록으로
        </button>
        <button type="button" onClick={onUpdate} disabled={saving}>
          {saving ? '저장 중...' : '저장'}
        </button>
      </div>
    </section>
  );
}

export default PostDetailPage;
